import React from 'react'
import PropTypes from 'prop-types'
import { TitleTertiary, SpacerHorizontal, SpacerVertical } from 'mage-deps/@klarna/bubble-ui'
import { Message } from 'mage-i18n'
import { stepIconSize } from './ProgressBarConstants'

Step.propTypes = {
  Icon: PropTypes.func,
  label: PropTypes.string,
  backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  vertical: PropTypes.bool
}

export function Step({ Icon, label, backgroundColor, vertical }) {
  const style = vertical
    ? { position: 'static' }
    : {
        position: 'absolute',
        top: stepIconSize,
        left: -2 * stepIconSize,
        width: 5 * stepIconSize,
        textAlign: 'center',
        display: 'flex'
      }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: vertical ? 'row' : 'column',
        alignItems: 'center',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor,
          width: stepIconSize,
          height: stepIconSize,
          borderRadius: '50%'
        }}
      >
        <Icon color="black" />
      </div>
      {vertical ? <SpacerHorizontal small /> : <SpacerVertical medium />}
      <div style={style}>
        <div style={{ flex: '1 1 auto' }}>
          {vertical ? null : <SpacerVertical extraSmall />}
          <TitleTertiary centered>
            <Message path={label} />
          </TitleTertiary>
        </div>
      </div>
    </div>
  )
}

export default Step
